import styled from "styled-components";

const StakingStyleWrapper = styled.div`
  background: #090a1a;
  padding: 80px 0 50px 0;

  .page_inner_row {
    margin-top: 30px;
  }
`;

export default StakingStyleWrapper;
